import React from "react";
import { IActionHeader } from "../../interfaces/Components/ActionHeader/IActionHeader";

import './ActionHeader.scss';

export const ActionHeader: React.FC<IActionHeader> = ({ title, children, ...props }) => {

    const className = `action-header ${props.className || ''}`;
    return (
        <div {...props} className={className}>
            <span>{title}</span>
            <div className="children">
                {children}
            </div>
        </div>
    );

}
